var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Pagination } from '@mui/material';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import '../styles/logReport.css';
import LogReportService from '../Services/LogReportService';
import Title from '../../App/components/Title';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import 'react-calendar/dist/Calendar.css';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Notification from '../../App/components/Notification';
function LogReport() {
    var _a = useState([]), logs = _a[0], setLogs = _a[1];
    var _b = useState(0), totalItems = _b[0], setTotalItems = _b[1];
    var _c = useState(1), currentPage = _c[0], setCurrentPage = _c[1];
    var perPage = useState(20)[0];
    var _d = useState(''), search = _d[0], setSearch = _d[1];
    var _e = useState(null), userId = _e[0], setUserId = _e[1];
    var _f = useState(null), dates = _f[0], setDates = _f[1];
    var _g = useState(''), startDate = _g[0], setStartDate = _g[1];
    var _h = useState(''), endDate = _h[0], setEndDate = _h[1];
    var _j = useState(false), arrowOpen = _j[0], setArrowOpen = _j[1];
    var _k = useState(''), referenceDates = _k[0], setReferenceDates = _k[1];
    var _l = useState([]), usersList = _l[0], setUsersList = _l[1];
    var _m = useState(false), hasSearched = _m[0], setHasSearched = _m[1];
    useEffect(function () {
        getUsers();
    }, []);
    useEffect(function () {
        if (hasSearched) {
            getLogs(currentPage, perPage, referenceDates || undefined, search || undefined, userId);
        }
    }, [currentPage]);
    useEffect(function () {
        if (dates != null && Array.isArray(dates)) {
            var start = dates[0], end = dates[1];
            if (start && end) {
                var formatLocal = function (date) {
                    var year = date.getFullYear();
                    var month = String(date.getMonth() + 1).padStart(2, '0');
                    var day = String(date.getDate()).padStart(2, '0');
                    return "".concat(year, "-").concat(month, "-").concat(day);
                };
                var reference_date = "".concat(formatLocal(start), "TO").concat(formatLocal(end));
                setReferenceDates(reference_date);
            }
        }
        else {
            setReferenceDates('');
        }
    }, [dates]);
    function getLogs(page, rows, period, searchFilter, userId) {
        var _a;
        if (page === void 0) { page = 1; }
        if (rows === void 0) { rows = 20; }
        return __awaiter(this, void 0, void 0, function () {
            var res, paginationData, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Notification().Block.circle('[data-id="log-report-grid"]');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, LogReportService.getLogs(page, rows, period, searchFilter, userId)];
                    case 2:
                        res = _b.sent();
                        paginationData = res.data.logs;
                        setLogs(paginationData.data || []);
                        setTotalItems(paginationData.total || 0);
                        Notification().Block.remove('[data-id="log-report-grid"]');
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        Notification().Block.remove('[data-id="log-report-grid"]');
                        if (((_a = err_1.response) === null || _a === void 0 ? void 0 : _a.status) === 403) {
                            Notification().Notify.failure('Usuário não tem permissão para visualizar essa página!');
                        }
                        else {
                            Notification().Notify.failure(err_1.message);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        Notification().Block.remove('[data-id="log-report-grid"]');
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function getUsers() {
        return __awaiter(this, void 0, void 0, function () {
            var res, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, LogReportService.getUsers()];
                    case 1:
                        res = _a.sent();
                        setUsersList(res.data.users || []);
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        Notification().Block.remove('[data-id="log-report-grid]');
                        Notification().Notify.failure(err_2.message);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    var handlePageChange = function (event, value) {
        if (value > Math.ceil(totalItems / perPage)) {
            return;
        }
        setCurrentPage(value);
    };
    var handleKeyDown = function (e) {
        if (e.key === 'Enter') {
            applyFilters();
        }
    };
    function applyFilters() {
        if (!search.trim()) {
            Notification().Notify.failure('Por favor, preencha o campo de busca!');
            return;
        }
        setHasSearched(true);
        setCurrentPage(1);
        getLogs(1, perPage, referenceDates || undefined, search || undefined, userId);
    }
    function clearFilters() {
        setSearch('');
        setUserId(null);
        setDates(null);
        setStartDate('');
        setEndDate('');
        setReferenceDates('');
        setCurrentPage(1);
        setHasSearched(false);
        setLogs([]);
        setTotalItems(0);
    }
    var getDisplayDate = function () {
        if (dates && Array.isArray(dates) && dates[0] && dates[1]) {
            var start = dates[0].toLocaleDateString('pt-BR');
            var end = dates[1].toLocaleDateString('pt-BR');
            return "".concat(start, " - ").concat(end);
        }
        return '';
    };
    var formatDate = function (dateString) {
        if (!dateString)
            return '-';
        var date = new Date(dateString);
        return new Intl.DateTimeFormat('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        }).format(date);
    };
    return (_jsxs("div", __assign({ className: "container-fluid log-report-container", "data-id": "log-report-grid" }, { children: [_jsx(Title, { text: "Hist\u00F3rico" }), _jsxs("div", __assign({ className: "card p-3 mb-3" }, { children: [_jsxs("div", __assign({ className: "input-group" }, { children: [_jsx("span", __assign({ className: "input-group-text-logs" }, { children: _jsx(SearchIcon, { fontSize: "small" }) })), _jsx("input", { type: "text", className: "form-control", placeholder: "Buscar por cliente, servi\u00E7o...", value: search, onChange: function (e) { return setSearch(e.target.value); }, onKeyDown: handleKeyDown, required: true })] })), _jsxs("div", __assign({ className: "row mt-3 g-2" }, { children: [_jsxs("div", __assign({ className: "col-12 col-md-4" }, { children: [_jsx("label", __assign({ className: "form-label" }, { children: "Per\u00EDodo" })), _jsxs("div", __assign({ className: "input-group custom-picker-container" }, { children: [_jsx("input", { type: "text", className: "form-control", value: getDisplayDate(), readOnly: true, onClick: function () { return setArrowOpen(!arrowOpen); }, style: {
                                                    cursor: 'pointer',
                                                    backgroundColor: '#fff',
                                                } }), _jsx("span", __assign({ className: "input-group-text", onClick: function () { return setArrowOpen(!arrowOpen); }, style: { cursor: 'pointer' } }, { children: _jsx(CalendarMonthIcon, {}) })), _jsx("div", __assign({ className: "picker-layer" }, { children: _jsx(DateRangePicker, { onChange: function (val) { return setDates(val); }, value: dates, isOpen: arrowOpen, onCalendarClose: function () { return setArrowOpen(false); }, className: "hidden-picker", format: "dd/MM/yyyy", locale: "pt-BR" }) }))] }))] })), _jsxs("div", __assign({ className: "col-12 col-md-4" }, { children: [_jsx("label", __assign({ className: "form-label" }, { children: "Funcion\u00E1rios/Administrador" })), _jsxs("select", __assign({ className: "form-select", value: userId || '', onChange: function (e) {
                                            return setUserId(e.target.value
                                                ? Number(e.target.value)
                                                : null);
                                        } }, { children: [_jsx("option", __assign({ value: "" }, { children: "Todos os funcion\u00E1rios" })), usersList.map(function (user) { return (_jsx("option", __assign({ value: user.id }, { children: user.name }), user.id)); })] }))] })), _jsxs("div", __assign({ className: "col-12 col-md-4 d-flex flex-column flex-md-row align-items-stretch align-items-md-end gap-2" }, { children: [_jsxs("button", __assign({ className: "btn-log-report", onClick: applyFilters }, { children: [_jsx(FilterAltIcon, { fontSize: "small" }), " Consultar"] })), _jsx("button", __assign({ className: "btn-clean-filter", onClick: clearFilters }, { children: "Limpar" }))] }))] }))] })), !hasSearched ? (_jsx("div", __assign({ className: "card p-5 text-center" }, { children: _jsx("p", { children: "Preencha o campo de Busca para visualizar os registros." }) }))) : (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "card p-3 d-none d-md-block" }, { children: _jsx("div", __assign({ className: "table-responsive" }, { children: _jsxs("table", __assign({ className: "table table-hover align-middle" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", __assign({ style: { width: '317px' } }, { children: "Funcion\u00E1rio/Administrador" })), _jsx("th", { children: "Log" }), _jsx("th", __assign({ style: { width: '150px' } }, { children: "Data" }))] }) }), _jsx("tbody", { children: logs.length === 0 ? (_jsx("tr", { children: _jsx("td", __assign({ colSpan: 3, className: "text-center" }, { children: "Nenhum registro encontrado" })) })) : (logs.map(function (item) { return (_jsxs("tr", { children: [_jsx("td", { children: item.user_name }), _jsx("td", { children: item.message }), _jsx("td", { children: formatDate(item.created_at) })] }, item.id)); })) })] })) })) })), _jsx("div", __assign({ className: "d-md-none" }, { children: logs.map(function (item) { return (_jsxs("div", __assign({ className: "card mb-2 p-3" }, { children: [_jsx("strong", { children: item.user_name }), _jsx("div", __assign({ className: "text-muted small" }, { children: formatDate(item.created_at) })), _jsx("div", { children: item.message })] }), item.id)); }) })), _jsx("div", __assign({ className: "d-flex justify-content-center justify-content-md-end mt-4" }, { children: _jsx(Pagination, { count: Math.ceil(totalItems / perPage), page: currentPage, onChange: handlePageChange, color: "standard", sx: {
                                '& .MuiPaginationItem-root': {
                                    color: '#ff8926',
                                },
                                '& .MuiPaginationItem-root.Mui-selected': {
                                    backgroundColor: '#ff8926',
                                    color: '#fff',
                                },
                                '& .MuiPaginationItem-root:hover': {
                                    backgroundColor: '#ff8926',
                                    color: '#fff',
                                },
                            }, showFirstButton: true, showLastButton: true }) }))] }))] })));
}
export default LogReport;
